// removed by extract-text-webpack-plugin
module.exports = {"root":"crops--root--3dkQMivK home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"crops--grid-container--3HInEKpq home--grid-container--3c3JLjRI","gridContainer":"crops--grid-container--3HInEKpq home--grid-container--3c3JLjRI","form-container":"crops--form-container--2It3LlWb home--message--9FSspPIv","formContainer":"crops--form-container--2It3LlWb home--message--9FSspPIv","title":"crops--title--T1oepYGs crops--title--3nbOw3vq","reminder":"crops--reminder--jZQLMYag"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-multiplier/crops/styles.css
// module id = ./views/refunds/cl-multiplier/crops/styles.css
// module chunks = 0